import { render, staticRenderFns } from "./MyProjectContractButtonArea.vue?vue&type=template&id=2c747546&scoped=true"
import script from "./MyProjectContractButtonArea.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyProjectContractButtonArea.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MyProjectContractButtonArea.vue?vue&type=style&index=0&id=2c747546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c747546",
  null
  
)

export default component.exports